import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Home } from "@/pages/Home";
import { PlayMode } from "@/pages/PlayMode";
import { GamePage } from "@/pages/GamePage";
import { Learn } from "@/pages/Learn";
import { Rules } from "@/pages/Rules";
import { RuleDetail } from "@/pages/RuleDetail";
import { Variants } from "@/pages/Variants";
import { Practice } from "@/pages/Practice";
import { Statistics } from "@/pages/Statistics";
import { Settings } from "@/pages/Settings";
import { About } from "@/pages/About";
import { Privacy } from "@/pages/Privacy";
import { Terms } from "@/pages/Terms";
import { Offline } from "@/pages/Offline";
import { NotFound } from "@/pages/NotFound";
import { Login } from "@/pages/Login";
import { Register } from "@/pages/Register";
import { ForgotPassword } from "@/pages/ForgotPassword";
import { ResetPassword } from "@/pages/ResetPassword";
import { Lobby } from "@/pages/Lobby";
import { Leaderboard } from "@/pages/Leaderboard";
import { OnlineGame } from "@/pages/OnlineGame";
import { VerifyAge } from "@/pages/VerifyAge";
import { Profile } from "@/pages/Profile";
import { Admin } from "@/pages/Admin";
import { useEffect } from "react";
import { useTheme } from "@/hooks/useTheme";
import { AuthProvider } from "@/hooks/useAuth";
import { RequireAuth } from "@/components/auth/RequireAuth";

function ThemeBoot() {
  useTheme();
  return null;
}

function App() {
  useEffect(() => {
    if ("scrollRestoration" in window.history) window.history.scrollRestoration = "auto";
  }, []);
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeBoot />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
          <Route path="/admin" element={<RequireAuth><Admin /></RequireAuth>} />
          <Route path="/play" element={<PlayMode />} />
          <Route path="/play/standard" element={<GamePage rulesetId="zimbabwe-standard" />} />
          <Route path="/play/:rulesetId" element={<GamePage />} />
          <Route path="/lobby" element={<RequireAuth><Lobby /></RequireAuth>} />
          <Route path="/verify-age" element={<RequireAuth><VerifyAge /></RequireAuth>} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/online/:gameId" element={<RequireAuth><OnlineGame /></RequireAuth>} />
          <Route path="/practice" element={<RequireAuth><Practice /></RequireAuth>} />
          <Route path="/learn" element={<Learn />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/rules/:country" element={<RuleDetail />} />
          <Route path="/variants" element={<Variants />} />
          <Route path="/statistics" element={<RequireAuth><Statistics /></RequireAuth>} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/offline" element={<Offline />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
